import moment from 'moment';

import {
  isValidString,
  isEmail,
  isPhoneNumber,
  isZipCode,
  isValidHttpUrl,
  ALL_UPPERCASE_LETTERS_REGEX,
  SPECIAL_CHARACTERS_REGEX,
} from '../util/string-validators';

export const required = (value: any) => {
  if (!value) {
    return 'Required';
  }
  if (typeof value === 'string' && !isValidString(value)) {
    return 'Required';
  }
  return undefined;
};

export const conditionalRequired = (condition: boolean) => (value: any) => {
  if (condition) {
    return required(value);
  }
  return undefined;
};

export const validatePhone = (value: string | null) => {
  if (!value) {
    return undefined;
  }
  if (!isPhoneNumber(value)) {
    return 'Must include exactly 10 numbers and no letters';
  }

  return undefined;
};

export const validateEmail = (value: string) => {
  if (!value) {
    return undefined;
  }

  if (!isEmail(value)) {
    return 'Please enter a valid email address';
  }

  return undefined;
};

export const validateUppercase = (value: string) => {
  if (!value) {
    return undefined;
  }

  if (value.match(new RegExp(ALL_UPPERCASE_LETTERS_REGEX))) {
    return 'Must not be all uppercase letters';
  }

  return undefined;
};

export const validateSpecialCharacters = (value: string) => {
  if (!value) {
    return undefined;
  }

  if (value.match(new RegExp(SPECIAL_CHARACTERS_REGEX))) {
    return 'Must not contain $, !, or *';
  }

  return undefined;
};

export const validateZipcode = (value: string) => {
  if (!value) {
    return undefined;
  }

  if (!isZipCode(value)) {
    return 'Please enter a valid zipcode';
  }

  return undefined;
};

export const ensureStartBeforeEnd = (startDate: string | null, endDate: string | null) => {
  if (!endDate || !startDate) {
    return undefined;
  }

  const start = moment(startDate, 'YYYY-MM-DD');
  const end = moment(endDate, 'YYYY-MM-DD');

  if (!start.isBefore(end, 'day')) {
    return 'Start date must be before end date';
  }

  return undefined;
};

export const validateHttpUrl = (url: string) => {
  if (!url) {
    return undefined;
  }

  if (!isValidHttpUrl(url)) {
    return 'Please enter a valid URL';
  }

  return undefined;
};
